<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-9 col-12">
        <div class="mt-4 card card-body">
          <Form 
          titlePage="Edit User"
          subtitlePage="Edit a User"
          submitButtonName="Update User"
          :onSubmit="onSubmit"
          :recordProps="record" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form.vue";
import UsersService from "@/services/users.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');


export default {
  name: "InternalUserEdit",
  components: {
    Form
  },

  data() {
    return {
      record: {},
    };
  },
  mounted(){
    this.getRecord()
  },
  methods: {
    showLoading(){
      toastId.value = toast.loading('Please wait...');
    },
    hideLoading(){
      setTimeout(() => {
        toast.remove(toastId.value)
      }, 1000); 
    },
    showSuccess(){
      toast.update(toastId.value, {
        render: "Update Successfully",
        closeOnClick: true,
        closeButton: true,
        type: 'success',
        isLoading: false,
        autoClose: 3000
      });
      
      setTimeout(() => {
        this.$router.replace('/internal-users')
      }, 1000);     
    },
    showFailed(e){
      toast.update(toastId.value, {
        render: e,
        closeOnClick: true,
        closeButton: true,
        type: 'error',
        isLoading: false,
        autoClose: 3000
      });
    },
    getRecord(){
      this.showLoading()

      UsersService.getInternal(this.$route.params.id).then(e => {
        this.record = e.data.registration_data
        this.record.password = ''
        this.hideLoading()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });
    },
    onSubmit(data){
      this.showLoading()
      let payload = {
          username: this.record.username,
          fullname: this.record.fullname,
          role_id: this.record.role_id,
        }


      if(data.password != ''){
        payload['password'] = data.password
      }

      UsersService.updateInternal(payload, this.$route.params.id).then(() => {
        this.showSuccess()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });

    }
  }
};
</script>
